function SupplierPageHandler(event = '', data = {}) {
    let finalData = {};
    switch (event) {
        case 'PageView':
            break;
        case 'Submit':
            break;
    }
    return finalData;
}

module.exports = { SupplierPageHandler }